<div
  class="page-content-cards container-content"
  fxLayout="column"
  *ngIf="!isLoading"
>
  <xng-breadcrumb [separator]="separatorIconTemplate">
    <ng-container
      *xngBreadcrumbItem="
        let breadcrumb;
        let info = info;
        let first = first
      "
    >
      <i class="bi bi-info-circle-fill" *ngIf="info && info === 'info'" aria-label="Info"></i>
      <i class="bi bi-house-fill" *ngIf="info && info === 'home'" aria-label="Home"></i>
      <ng-container *ngIf="!first">{{
        breadcrumb | translate
      }}</ng-container>
    </ng-container>
  </xng-breadcrumb>

  <ng-template #separatorIconTemplate>
    <i class="bi bi-caret-right-fill"></i>
  </ng-template>

  <div class="page-block" fxFlexAlign="center">
    <app-dashboard-exam-card
      *ngFor="let item of items"
      [exam]="item"
    ></app-dashboard-exam-card>
  </div>
</div>

<app-loading-indicator-full
  *ngIf="isLoading"
></app-loading-indicator-full>
